import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=5c312476"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=5c312476&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports